jQuery(function ($) {
	var MOBILE_MAX = 990;

	// On load, for mobile: move each panel directly after its tab
	if (window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches) {
		$('.block-tabbed-content').each(function () {
			var $wrapper = $(this);
			var $tabs = $wrapper.find('.tabbed-content__tab');
			var $panels = $wrapper.find('.tabbed-content__panels .tabbed-content-item');

			// Ensure same order: tab 0 -> panel 0, etc.
			$tabs.each(function (i) {
				var $panel = $panels.eq(i);
				if ($panel.length) {
					$panel.insertAfter($(this));
				}
			});
		});
	}

	// Handle tab click
	$(document).on('click', '.tabbed-content__tab', function () {
		var $button = $(this);
		var $wrapper = $button.closest('.block-tabbed-content');

		if (!$wrapper.length) return;

		var index = $button.data('tab-index');

		var $tabs = $wrapper.find('.tabbed-content__tab');
		var $panels = $wrapper.find('.tabbed-content-item');

		$tabs.each(function (i) {
			$(this).toggleClass('is-active', String(i) === String(index));
		});

		$panels.each(function (i) {
			$(this).toggleClass('is-active', String(i) === String(index));
		});
	});

	// Set first tab/panel active if not already
	$('.block-tabbed-content').each(function () {
		var $wrapper = $(this);
		var $tabs = $wrapper.find('.tabbed-content__tab');
		var $panels = $wrapper.find('.tabbed-content-item');

		if (!$tabs.length || !$panels.length) return;

		var hasActiveTab = $tabs.filter('.is-active').length > 0;
		var hasActivePanel = $panels.filter('.is-active').length > 0;

		if (!hasActiveTab) {
			$tabs.first().addClass('is-active');
		}

		if (!hasActivePanel) {
			$panels.first().addClass('is-active');
		}
	});
});
